
import * as FeedbackSurveyWebAPIUtils from "utils/feedbackSurveyWebAPIUtils";

export function getSurveyData(reqData, onlyFetch) {
    FeedbackSurveyWebAPIUtils.getSurveyData(reqData, onlyFetch);
}

export function postSurveyData(reqData) {
    FeedbackSurveyWebAPIUtils.postSurveyData(reqData);
}
